import React, { useEffect } from "react";
import { useCrud } from "../common/crudCard/useCrud";
import { CrudLayout } from "../common/crudCard/crudLayout";
import { useHistory } from "react-router-dom";
import { getCategorias, deleteCategoria } from "../../services/categoriasService";
import { cleanString } from "../utils/cleanString";
import CategoriasTable from "./categoriasTable";

export default function CondicionesIva(props) {
  const { onLoading, onDoneLoading } = props;

  const title = "Categorias";

  const breadcrumbs = [
    {
      title: "Inicio",
      link: "/main",
    },
    {
      title: "Categorias",
    },
  ];

  const history = useHistory();

  const filterData = (records, query) => {
    return records.filter((m) => cleanString(m.descripcion).includes(cleanString(query)));
  };

  const checkBeforeDelete = async (id) => {
    // const canDelete = await checkDeleteCondicionIva(id);
    // return canDelete;
  };

  const onDelete = async (id) => {
    try {
      await deleteCategoria(id);
    } catch (ex) {
      throw ex;
    }
  };

  const crud = useCrud({
    defaultPath: "/categorias",
    defaultSortColumn: { path: "descripcion", order: "asc" },
    checkBeforeDelete,
    filterData,
    onDelete,
    onLoading,
    onDoneLoading,
  });

  const fetchData = async () => {
    onLoading();
    const registros = await getCategorias();
    onDoneLoading();
    if (registros === "NETWORK ERROR") return history.push("/noconnection");
    crud.updateAllRecords(registros);
  };

  const handleSearch = (query) => {
    crud.setSearchQuery(query);
    crud.setCurrentPage(1);
  };

  useEffect(() => {
    if (!crud.mounted) {
      fetchData();
      crud.setMounted(true);
    }
  }, []);

  return (
    <CrudLayout
      title={title}
      breadcrumbs={breadcrumbs}
      newLink="/categorias/nueva"
      permisos={crud.permisos}
      filterData={filterData}
      onChangeSearch={handleSearch}
      onPageChange={crud.handlePageChange}
      totalCount={crud.totalCount}
      pageSize={crud.pageSize}
      currentPage={crud.currentPage}
    >
      <CategoriasTable
        permisos={crud.permisos}
        records={crud.records}
        onDelete={(id) => crud.handleDelete(id)}
        onEdit={(id) => crud.handleEdit(id)}
        onSort={(sortColumn) => crud.handleSort(sortColumn)}
        onView={(id) => crud.handleView(id)}
        sortColumn={crud.sortColumn}
      />
    </CrudLayout>
  );
}
